
<div class="appointment-dialog">
  <div class="content">
    <h1>Prendre un rendez-vous</h1>
    <form #appointmentForm="ngForm" class="appointment-form">

      @if (!isReschedule) {
        <mat-form-field>
          <mat-label>Choisir une date</mat-label>
          <input required matInput [matDatepicker]="picker" name="appointmentDate" [(ngModel)]="appointment.appointmentDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      }

      @if (isReschedule) {
        <mat-form-field>
          <mat-label>Date alternative</mat-label>
          <input required matInput [matDatepicker]="picker1" name ="rescheduleDate" [(ngModel)]="appointment.rescheduleDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      }

      @if (!isReschedule) {
        <mat-form-field>
          <mat-label>Services demandés</mat-label>
          <mat-select required multiple name="services" [(ngModel)]="appointment.services">
            @for (serv of serviceTypes; track serv) {
              <mat-option [value]="serv.code" >{{serv.title}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (!isReschedule) {
        <mat-form-field>
          <mat-label>Lieu du rendez vous</mat-label>
          <mat-select required name="location" [(ngModel)]="appointment.locationMode">
            @for (loc of locationModes; track loc) {
              <mat-option [value]="loc.code" >{{loc.title}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      <mat-form-field >
        <mat-label >Message</mat-label>
        <textarea required matInput type="text"  [readonly]="isReschedule" name ="details" placeholder=""  [(ngModel)]="appointment.details" ></textarea>
      </mat-form-field>

      <h5>Vous rappeller ?

        <mat-slide-toggle
          class="example-margin"
          name = "needCallback"
          [disabled]="isReschedule"
          [(ngModel)]="appointment.needCallback"
          >
          <!-- (change)="onWithDriverChange() " -->
        </mat-slide-toggle>
      </h5>

    </form>

    <div class="action-buttons">
      <button class="simple-button-buy" mat-button (click)="onNoClick();$event.stopPropagation()">Annuler</button>

      <button class="cta-button-buy" [disabled] = !appointmentForm.valid mat-button (click)="submitAppointment();$event.stopPropagation()">
        <mat-icon>schedule_send</mat-icon>Soumettre
      </button>
    </div>
  </div>
</div>

